import React from "react";

/**
 * Small collection of tailored skeleton placeholders. These render immediately
 * on cold navigation and are replaced when real data arrives — never a
 * full-page spinner and never a "connection error" screen while a fetch is
 * in-flight (see queryCache.js `hasStaleData`).
 */

export function SkeletonLine({ className = "" }) {
  return (
    <div
      data-testid="skeleton-line"
      className={`animate-pulse rounded bg-black/5 ${className}`}
    />
  );
}

export function SkeletonBlock({ className = "", "data-testid": testId }) {
  return (
    <div
      data-testid={testId || "skeleton-block"}
      className={`animate-pulse rounded-lg bg-black/5 ${className}`}
    />
  );
}

export function SkeletonCard() {
  return (
    <div className="rounded-xl border border-black/10 p-4 space-y-3" data-testid="skeleton-card">
      <SkeletonLine className="h-3 w-1/3" />
      <SkeletonLine className="h-6 w-2/3" />
      <SkeletonLine className="h-3 w-1/2" />
    </div>
  );
}

export function SkeletonListItem() {
  return (
    <div className="flex items-center gap-3 py-3" data-testid="skeleton-list-item">
      <div className="h-10 w-10 animate-pulse rounded-full bg-black/5" />
      <div className="flex-1 space-y-2">
        <SkeletonLine className="h-3 w-2/3" />
        <SkeletonLine className="h-3 w-1/3" />
      </div>
    </div>
  );
}

export function SkeletonList({ count = 4 }) {
  return (
    <div className="divide-y divide-black/5">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonListItem key={i} />
      ))}
    </div>
  );
}
